export default "__VITE_ASSET__4080ae2e__"